const Question = ({ left, right, answer, onAnswer }) => {
  return (
    <section className="question">
      <div className="question-text">
        <span>{left}</span>
        <span>{right}</span>
      </div>
      {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map((num) => (
        <button
          key={num}
          style={{ background: answer === num ? "grey" : "lightgrey" }}
          onClick={() => {
            onAnswer(num);
          }}
        >
          {num}
        </button>
      ))}
    </section>
  );
};

export default Question;
